import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { HighwayConcession } from "./HighwayConcession";
import { TollStationProps } from "./types";

export class TollStation extends BaseModel<TollStationProps> {
	id: string;
	name: string;
	code: string;
	highwayConcession: HighwayConcession;

	constructor(data: TollStationProps) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
		this.highwayConcession = HighwayConcession.getValueOrNew(data.highwayConcession);
	}

	toOption = (): OptionLike => {
		return { ...this, label: this.name, value: this.id };
	};
}
